<template>
  <div class="menuBg w-full h-48px flex items-center pl-8 pr-8">
    <div
      class="!ml-5 !mr-5 flex flex-col items-center"
      v-for="(item, index) in menuList"
      :key="index"
      @click="changeSelect(item, index)"
    >
      <el-dropdown v-show="item.isDrop === true" trigger="click" @command="handleCommand">
        <span
          class="el-dropdown-link text-14px cursor-pointer"
          :class="index === activeIndex ? 'avtive' : ''"
          style="color: #affcff"
        >
          {{ item.lable || item.menuList[0].lable
          }}<i class="el-icon-caret-bottom el-icon--right"></i>
        </span>
        <span v-show="index === activeIndex" class="w-full h-7px mt-6px -mb-10px activeBg"></span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(it, i) in item.menuList"
            :key="i"
            :command="{ itLable: it.lable, itValue: it.value, itemLabel: item.label }"
            @command="handleCommand"
            >{{ it.lable }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <span
        v-show="item.isDrop === false"
        :class="index === activeIndex ? 'avtive' : ''"
        class="text-14px cursor-pointer"
        style="color: #affcff"
        >{{ item.lable }}</span
      >
      <span v-show="index === activeIndex" class="w-full h-7px mt-6px -mb-10px activeBg"></span>
    </div>
  </div>
</template>

<script>
import { constants } from 'fs'

export default {
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
    menuList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    activeIndex: {
      immediate: true,
      handler(val) {},
    },
  },
  data() {
    return {}
  },
  methods: {
    changeSelect(row, index) {
      row.isDrop === false ? this.$emit('command', '') : ''
      this.$emit('selectIndex', index)
      if (row.label === '取样检验') {
        this.$emit('command', { itValue: row.value })
      } else if (row.label === '金属检验委托单') {
        this.$emit('command', { itValue: row.value })
      } else if (row.label === '历次检修计划') {
        this.$emit('command', { itValue: row.value })
      }
    },
    handleCommand(command) {
      // _.map(item.menuList, (it) => {
      //   it.vlaue === command ? (item.lable = it.lable) : ''
      // })
      this.$emit('command', command)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/metal.scss';
.menuBg {
  background: url('../../../assets/images/metal/tableMenu.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
.avtive {
  font-size: 16px;
  text-shadow: rgba(0, 242, 229, 1) 0px 0px 10px;
}
.activeBg {
  background: url('../../../assets/images/metal/tableSelect.png') 0 0 no-repeat;
  background-size: 100% 100%;
}
</style>
